<app-header class="mHeader"></app-header>
<div class="page hug-dashboard-page">
  <main class="mContent overflow-auto overflow-x-hidden hug-start-page">
    <app-section-loader [loading]="loading"></app-section-loader>
    <form [formGroup]="updateStudentProgressGroup">
      <div class="hug-tutor-bg mat-typography">
        <section class="hug-tutor-banner">
          <div class="hug-container hug-container--tutor-banner">
            <div class="hug-tutor-content">
              <div class="hug-tutor-content__left">
                <img src="assets/images/tutor/tutor-banner.svg" alt="Tutor banner" />
              </div>
              <div class="hug-tutor-content__right">
                <h1 class="hug-h1 text-primary">H.U.G. Classroom</h1>
                <span class="quick-help"><strong>NEED HELP?</strong> Please click the help button in ZOOM</span>
                <div class="position-relative">
                  <mat-form-field class="hug-dropdown-main">
                    <mat-label>Select School</mat-label>
                    <mat-select [(ngModel)]="selectedSchool" required (selectionChange)="onSchoolChange($event)"
                      panelClass="hug-start-page-select-panel"
                      [disabled]="false" [ngModelOptions]="{ standalone: true }">
                      <mat-option>
                        <ngx-mat-select-search style="width: 100%" [formControl]="schoolControl"
                          [noEntriesFoundLabel]="'No matching School found'" placeholderLabel="Search School">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let school of schoolOptions" [value]="school.id">
                        {{ school.school_name }}
                        {{ school.uuid ? "(" + school.uuid + ")" : "" }}
                      </mat-option>
                    </mat-select>
                    <span class="hug-dropdown-main__icon">
                      <img src="assets/images/tutor/hug-icon-school.svg" alt="Icon school" />
                    </span>
                  </mat-form-field>
                </div>

                <div class="position-relative">
                  <mat-form-field class="hug-dropdown-main" [ngClass]="
                      !loading &&
                      selectedSchool !== -1 &&
                      studentList?.length === 0
                        ? 'mb-4'
                        : ''
                    ">
                    <mat-label>Select Student</mat-label>
                    <mat-select [(ngModel)]="selectedStudent" required (selectionChange)="onStudentChange($event)"
                      panelClass="hug-start-page-select-panel"
                      [disabled]="
                        !studentListLoadingInProgress &&
                        selectedSchool == -1 &&
                        studentList?.length === 0
                      " [ngModelOptions]="{ standalone: true }">
                      <mat-option>
                        <ngx-mat-select-search style="width: 100%" [formControl]="studentControl"
                          [noEntriesFoundLabel]="'No matching Student found'" placeholderLabel="Search Student">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let student of filteredStudentList" [value]="student.id">
                        {{ maskLastName(student.UserName) }}
                      </mat-option>
                    </mat-select>
                    <span class="hug-dropdown-main__icon">
                      <img src="assets/images/tutor/hug-icon-user.svg" alt="Icon Student" />
                    </span>
                    <mat-hint class="mat-error text-danger" *ngIf="
                        !studentListLoadingInProgress &&
                        selectedSchool !== -1 &&
                        studentList?.length === 0
                      ">
                      There are no students available in the school</mat-hint>
                  </mat-form-field>
                  <app-section-loader [loading]="studentListLoadingInProgress"></app-section-loader>
                </div>

                <div class="position-relative">
                  <mat-form-field class="hug-dropdown-main hug-datepicker" (click)="picker.open()">
                    <mat-label>Choose a date</mat-label>
                    <input matInput required formControlName="recorded_date" [matDatepicker]="picker" readonly />
                    <span matSuffix class="mat-mdc-select-arrow-wrapper hug-datepicker-caret">
                      <span class="mat-mdc-select-arrow"></span>
                    </span>
                    <mat-datepicker #picker></mat-datepicker>

                    <span class="hug-dropdown-main__icon">
                      <img src="assets/images/tutor/hug-icon-date.svg" alt="Icon date" />
                    </span>
                  </mat-form-field>
                </div>

                <div class="position-relative">
                  <div class="d-flex custom-gap">
                    <div class="flex-fill">
                      <mat-form-field class="hug-dropdown-main" [ngClass]="
                      !lessonListLoadingInProgress &&
                      studentId !== -1 &&
                      lessonOptions?.length === 0
                        ? 'mb-4'
                        : ''
                    ">
                        <mat-label>Lesson</mat-label>
                        <mat-select [(ngModel)]="selectedLesson1" required panelClass="hug-start-page-select-panel" [disabled]="
                        selectedStudent == -1
                      " (selectionChange)="setSelectedLesson($event.value)" formControlName="lesson">
                          <mat-option>
                            <ngx-mat-select-search [formControl]="lessonControl"
                              [noEntriesFoundLabel]="'No matching lesson found'" placeholderLabel="Search lesson">
                            </ngx-mat-select-search>
                          </mat-option>
                          <mat-option *ngFor="let lesson of lessonOptions" [value]="lesson.id">
                            Lesson {{ lesson.lesson_plan_number }} -
                            {{ lesson.lesson_plan_name }}
                          </mat-option>
                        </mat-select>
                        <span class="hug-dropdown-main__icon">
                          <img src="assets/images/tutor/hug-icon-book.svg" alt="Icon Lesson" />
                        </span>
                        <mat-hint class="mat-error text-danger" *ngIf="
                        !lessonListLoadingInProgress &&
                        studentId !== -1 &&
                        lessonsLoaded &&
                        lessonOptions?.length === 0
                      ">
                          No more lessons are pending for the student</mat-hint>
                      </mat-form-field>
                      <app-section-loader [loading]="lessonListLoadingInProgress"></app-section-loader>
                    </div>
                  </div>

                </div>

                <label class="hug-label" id="was-student-absent">Was the student absent?</label>
                <mat-radio-group class="hug-radio-group" aria-label="was-student-absent"
                  (change)="checkBoxChanges($event)" formControlName="control_group" *ngIf="!edit">
                  <mat-radio-button [value]="true" (keydown.enter)="$event.preventDefault()">Yes</mat-radio-button>
                  <mat-radio-button [value]="false" checked
                    (keydown.enter)="$event.preventDefault()">No</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </section>

        <div class="hug-tutor-separator">
          <img src="assets/images/tutor/tutor-separator.svg" alt="Separator graphics" role="presentation" />
        </div>
        <div class="hug-button-container" *ngIf="!wasStudentAbsent">
          <div class="hug-sp-button-grid">
            <div class="hug-zoom-session-info">
            <p>Join the zoom classroom of the selected session</p>
            <button [disabled]="!zoomLink" mat-raised-button color="primary" class="btn btn-primary custom-zoom-btn" (click)="openZoomClassroom()">
              <img src="../../../../../assets/assets/images/svg/zoom-icon.svg" alt="zoom-icon">
              <span class="label">Open Zoom Classroom</span>
            </button>
            </div>
            <!-- Top Button -->
            <div class="hug-sp-button-top">
              <button mat-raised-button color="primary" [disabled]="!isLessonSelected"
                (click)="openHugLesson(updateStudentProgressGroup.value)" class="hug-main-button miro-btn"
                [style.color]="miroBoardLink ? '#000080' : 'white'">
                Open H.U.G. Lesson
              </button>
            </div>

            <!-- Bottom Buttons -->
            <div class="hug-sp-button-bottom">
              <button mat-raised-button color="primary"
                class="hug-main-button miro-btn d-flex align-items-center justify-content-center"
                (click)="tutorTipModalOpen(true)" [disabled]="!isLessonSelected">
                <img src="../../../assets/assets/images/svg/info-white.svg" alt="Info icon">
                <span> Tutor Tips</span>
              </button>
              <button mat-raised-button color="primary" class="hug-main-button miro-btn"
                (click)="onNiceToMeetYouClick()">
                <img src="../../../assets/assets/images/svg/hand-shake.svg" alt="Meeting icon">
                <span> Nice to Meet You</span>
              </button>
            </div>
          </div>
        </div>

        <section class="hug-tutor-confirm hug-tutor-reason-confirm" *ngIf="wasStudentAbsent">
          <div class="hug-container">
            <mat-form-field class="hug-dropdown-main hug-tutor-reason-select">
              <mat-label>Reason for Absence</mat-label>
              <mat-select [formControl]="reasonControl" [required]="wasStudentAbsent" panelClass="hug-start-page-select-panel"
                (selectionChange)="setSelectedReasoForAbsence($event.value)">
                <mat-option *ngFor="let reason of reasons" [value]="reason.id">
                  {{ reason.reason_name | titlecase }}
                </mat-option>
              </mat-select>
              <span class="hug-dropdown-main__icon">
                <img src="assets/images/tutor/hug-icon-reason.svg" alt="Icon Reason" />
              </span>
            </mat-form-field>
            <div class="hug-tutor-btns" *ngIf="wasStudentAbsent">
              <button class="hug-btn hug-btn--primary-outline" mat-button color="primary"
                (click)="handleStudentAbsentCancel()">
                Cancel
              </button>
              <button class="hug-btn hug-btn--primary" mat-button #toggleButton
                (click)="updateProgress(updateStudentProgressGroup.value)" color="primary">
                Save
              </button>
            </div>
          </div>
        </section>
      </div>
    </form>

    <div class="modal" [ngClass]="{'active':tutorTipModal}" id="modalExample">
      <div class="modal__box">
        <div class="modal__header">
          <h2>Tutor Tips</h2>
          <button class="close" aria-label="Close" (click)="tutorTipModalOpen(false)">×</button>
        </div>
        <div class="modal__body">
          <p [innerHTML]="tutorTip"></p>
        </div>
      </div>
    </div>
  </main>
  <footer class="hug-tutor-footer">
    <div class="hug-container">
      <p class="hug-copyright">© Help Us Grow Reading Program</p>
    </div>
  </footer>
</div>